export const mapEventValuesName = (filterKey) => {
  switch (filterKey) {
    case 'minStarRating':
      return {
        groupName: 'Hotel Rating',
        itemName: 'hotel rating',
      };
    case 'minTripadvisorRating':
      return {
        groupName: 'Tripadvisor Rating',
        itemName: 'tripadvisor rating',
      };
    default:
  }
};
